// Panel structure retained from the original retail report designs. Values come from the report API.
export const RETAIL_ANALYTICS_LAYOUTS = {
  "margin-by-category": {
    "subtitle": "Theo dõi doanh số, giá vốn, chiết khấu và biên lợi nhuận theo ngành hàng chính.",
    "filters": [
      "Ngành hàng",
      "Kỳ",
      "Phân tích",
      "Góc nhìn"
    ],
    "metricLabels": [
      "GM toàn ngành",
      "Loa kéo",
      "Dàn karaoke",
      "Phụ kiện"
    ],
    "panels": [
      {
        "type": "stacked",
        "width": "span-8",
        "title": "Cấu phần doanh số - giá vốn - biên",
        "subtitle": "So sánh theo ngành hàng."
      },
      {
        "type": "leaderboard",
        "width": "span-4",
        "title": "Ngành hàng dẫn biên",
        "subtitle": "Xếp hạng theo % GM."
      },
      {
        "type": "table",
        "width": "span-12",
        "title": "Biên lợi nhuận chi tiết",
        "subtitle": "Cần dùng để quyết định khuyến mại, giá bán và danh mục đẩy doanh số.",
        "columns": [
          "Ngành hàng",
          "Doanh số",
          "Giá vốn",
          "Chiết khấu",
          "Biên gộp",
          "Khuyến nghị"
        ]
      }
    ]
  },
  "sku-and-slow-moving": {
    "subtitle": "Theo dõi SKU bán nhanh, hàng bán chậm và cơ hội dọn tồn / cân đối nhập hàng.",
    "filters": [
      "Khoảng ngày",
      "Loại SKU",
      "Kho / cửa hàng",
      "Trạng thái"
    ],
    "metricLabels": [
      "SKU bán nhanh",
      "SKU bán chậm",
      "Tồn chậm > 60 ngày",
      "Tỷ lệ hết hàng"
    ],
    "panels": [
      {
        "type": "leaderboard",
        "width": "span-4",
        "title": "Top SKU bán nhanh",
        "subtitle": "Theo số lượng ra trong 30 ngày."
      },
      {
        "type": "bars",
        "width": "span-4",
        "title": "Tuổi tồn theo nhóm SKU",
        "subtitle": "Tỷ trọng giá trị tồn."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "SKU bán chậm cần xử lý",
        "subtitle": "Ưu tiên dọn tồn và xoay vòng vốn.",
        "columns": [
          "SKU",
          "Tồn",
          "DOI",
          "Đề xuất"
        ]
      },
      {
        "type": "alerts",
        "width": "span-12",
        "title": "Khuyến nghị xử lý SKU",
        "subtitle": "Tối ưu vòng quay và cân bằng nhập hàng."
      }
    ]
  },
  "inventory-aging": {
    "subtitle": "Kiểm soát giá trị tồn, tuổi tồn, khả năng bán và rủi ro thanh lý của toàn bộ hệ thống.",
    "filters": [
      "Kho",
      "Ngành hàng",
      "Cắt lớp",
      "Tiêu chí"
    ],
    "metricLabels": [
      "Tổng tồn kho",
      "Sell-through 30d",
      "Tồn chậm > 90 ngày",
      "Giá trị hàng rủi ro"
    ],
    "panels": [
      {
        "type": "donut",
        "width": "span-4",
        "title": "Phân bổ tuổi tồn",
        "subtitle": "Theo giá trị hàng hóa."
      },
      {
        "type": "bars",
        "width": "span-4",
        "title": "Tồn theo kho",
        "subtitle": "Giá trị tỷ đồng."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "Danh mục rủi ro",
        "subtitle": "Tồn cao nhưng bán chậm.",
        "columns": [
          "Nhóm hàng",
          "Tồn",
          "Sell-through",
          "Hành động"
        ]
      },
      {
        "type": "alerts",
        "width": "span-12",
        "title": "Rủi ro tồn kho",
        "subtitle": "Các hành động nên thực hiện trong tuần."
      }
    ]
  },
  "replenishment-forecast": {
    "subtitle": "Gợi ý đặt hàng, cân đối tồn và dự báo bán ra cho các nhóm SKU chiến lược.",
    "filters": [
      "Chu kỳ mua",
      "Mô hình",
      "NCC",
      "Kho mục tiêu"
    ],
    "metricLabels": [
      "SKU cần bổ sung",
      "Giá trị đề xuất mua",
      "Độ chính xác forecast",
      "Nguy cơ OOS"
    ],
    "panels": [
      {
        "type": "line",
        "width": "span-8",
        "title": "Forecast bán ra theo tuần",
        "subtitle": "So sánh forecast với thực tế."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "Danh mục cần đặt hàng",
        "subtitle": "Ưu tiên theo nguy cơ out-of-stock.",
        "columns": [
          "SKU",
          "Tồn còn",
          "Lead time",
          "Đề xuất"
        ]
      },
      {
        "type": "alerts",
        "width": "span-12",
        "title": "Khuyến nghị mua hàng",
        "subtitle": "Phục vụ phòng mua hàng và điều phối tồn."
      }
    ]
  },
  "promotion-and-basket": {
    "subtitle": "Đo hiệu quả khuyến mại, combo và tỷ lệ bán kèm để tối ưu biên lợi nhuận.",
    "filters": [
      "Chiến dịch",
      "Cửa hàng",
      "Sản phẩm gốc",
      "Kênh"
    ],
    "metricLabels": [
      "Tỷ lệ bán kèm",
      "GM sau KM",
      "ROI khuyến mại",
      "Giảm giá bình quân"
    ],
    "panels": [
      {
        "type": "funnel",
        "width": "span-4",
        "title": "Phễu chiến dịch",
        "subtitle": "Từ traffic đến hóa đơn có combo."
      },
      {
        "type": "stacked",
        "width": "span-4",
        "title": "Hiệu quả combo",
        "subtitle": "Tỷ trọng doanh số theo loại bán."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "Top combo hiệu quả",
        "subtitle": "Ưu tiên triển khai theo showroom.",
        "columns": [
          "Combo",
          "Attach rate",
          "GM",
          "ROI"
        ]
      }
    ]
  },
  "returns-and-defects": {
    "subtitle": "Giám sát tỷ lệ đổi trả, lỗi sản phẩm, nguyên nhân và chi phí hoàn nhập.",
    "filters": [
      "Kỳ",
      "Nguồn trả",
      "Loại lỗi",
      "NCC"
    ],
    "metricLabels": [
      "Tỷ lệ đổi trả",
      "Chi phí hoàn nhập",
      "Lỗi DOA",
      "Thời gian xử lý"
    ],
    "panels": [
      {
        "type": "donut",
        "width": "span-4",
        "title": "Nguyên nhân đổi trả",
        "subtitle": "Theo số lượng phiếu đổi trả."
      },
      {
        "type": "line",
        "width": "span-4",
        "title": "Xu hướng đổi trả 8 tuần",
        "subtitle": "Tỷ lệ đổi trả và lỗi DOA."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "NCC cần theo dõi",
        "subtitle": "Theo tỷ lệ lỗi và tốc độ xử lý bảo hành.",
        "columns": [
          "NCC",
          "Tỷ lệ lỗi",
          "Lead time BH",
          "Trạng thái"
        ]
      }
    ]
  },
  "loyalty-and-cohort": {
    "subtitle": "Đánh giá tăng trưởng thành viên, cohort quay lại và giá trị vòng đời khách hàng.",
    "filters": [
      "Segment",
      "Cohort",
      "Kênh",
      "Thước đo"
    ],
    "metricLabels": [
      "Thành viên hoạt động",
      "Repeat rate",
      "LTV 12 tháng",
      "Tỷ lệ rời bỏ"
    ],
    "panels": [
      {
        "type": "heatmap",
        "width": "span-8",
        "title": "Cohort mua lại",
        "subtitle": "Tỷ lệ quay lại theo tháng đầu mua.",
        "columns": [
          "M+0",
          "M+1",
          "M+2",
          "M+3",
          "M+4",
          "M+5"
        ]
      },
      {
        "type": "donut",
        "width": "span-4",
        "title": "Cơ cấu hạng thành viên",
        "subtitle": "Theo doanh số lũy kế."
      },
      {
        "type": "table",
        "width": "span-12",
        "title": "Nhóm khách cần chăm sóc",
        "subtitle": "Ưu tiên remarketing và loyalty automation.",
        "columns": [
          "Nhóm",
          "Số khách",
          "Doanh số 12T",
          "Tỷ lệ quay lại",
          "Đề xuất"
        ]
      }
    ]
  },
  "cashier-and-shifts": {
    "subtitle": "Theo dõi hiệu quả thu ngân, năng suất ca, tốc độ xử lý và sai lệch cuối ca.",
    "filters": [
      "Cửa hàng",
      "Ca bán",
      "Kỳ",
      "Thiết bị POS"
    ],
    "metricLabels": [
      "Hóa đơn/ca",
      "Thời gian xử lý",
      "Sai lệch két",
      "Tỷ lệ hủy bill"
    ],
    "panels": [
      {
        "type": "leaderboard",
        "width": "span-4",
        "title": "Top thu ngân",
        "subtitle": "Theo hóa đơn và tốc độ xử lý."
      },
      {
        "type": "timeline",
        "width": "span-4",
        "title": "Hiệu suất theo ca",
        "subtitle": "Theo khung giờ cao điểm."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "POS cần theo dõi",
        "subtitle": "Các quầy có dấu hiệu nghẽn.",
        "columns": [
          "POS",
          "Bill/ngày",
          "Lỗi",
          "Trạng thái"
        ]
      }
    ]
  },
  "debt-and-cashflow": {
    "subtitle": "Theo dõi công nợ phải thu, phải trả và nhu cầu dòng tiền vận hành ngắn hạn.",
    "filters": [
      "Kỳ",
      "Khối",
      "Aging",
      "Đơn vị"
    ],
    "metricLabels": [
      "Phải thu",
      "Phải trả",
      "Dòng tiền 14 ngày",
      "Quá hạn > 60 ngày"
    ],
    "panels": [
      {
        "type": "bars",
        "width": "span-4",
        "title": "Aging công nợ phải thu",
        "subtitle": "Theo bucket ngày."
      },
      {
        "type": "line",
        "width": "span-4",
        "title": "Dòng tiền 6 tuần",
        "subtitle": "Thu - chi dự kiến."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "Khoản phải thu trọng yếu",
        "subtitle": "Ưu tiên thu hồi.",
        "columns": [
          "Khách hàng",
          "Số dư",
          "Quá hạn",
          "Phụ trách"
        ]
      }
    ]
  },
  "supplier-and-leadtime": {
    "subtitle": "Đánh giá chất lượng nhà cung cấp theo lead time, fill rate, lỗi hàng và độ ổn định.",
    "filters": [
      "Nhà cung cấp",
      "Kỳ",
      "Chỉ tiêu",
      "Nhóm hàng"
    ],
    "metricLabels": [
      "Lead time TB",
      "Fill rate",
      "OTIF",
      "Tỷ lệ lỗi NCC"
    ],
    "panels": [
      {
        "type": "bars",
        "width": "span-6",
        "title": "Lead time theo NCC",
        "subtitle": "Đơn vị: ngày."
      },
      {
        "type": "table",
        "width": "span-6",
        "title": "Supplier scorecard",
        "subtitle": "Kết hợp OTIF, lỗi hàng, phản hồi và giá.",
        "columns": [
          "NCC",
          "OTIF",
          "Fill rate",
          "Score",
          "Hành động"
        ]
      },
      {
        "type": "alerts",
        "width": "span-12",
        "title": "Điểm cần xử lý với NCC",
        "subtitle": "Góc nhìn cho mua hàng và QA."
      }
    ]
  },
  "omnichannel-conversion": {
    "subtitle": "Đo hành trình từ lead online đến mua tại showroom, call center và website.",
    "filters": [
      "Kênh",
      "Mục tiêu",
      "Kỳ",
      "Store pickup"
    ],
    "metricLabels": [
      "Lead đủ chuẩn",
      "Tỷ lệ đến showroom",
      "Tỷ lệ chốt đa kênh",
      "CPA bình quân"
    ],
    "panels": [
      {
        "type": "funnel",
        "width": "span-4",
        "title": "Phễu đa kênh",
        "subtitle": "Lead đến hóa đơn."
      },
      {
        "type": "line",
        "width": "span-4",
        "title": "Hiệu quả kênh theo ngày",
        "subtitle": "Conversion trend 14 ngày."
      },
      {
        "type": "table",
        "width": "span-4",
        "title": "Nguồn hiệu quả nhất",
        "subtitle": "Theo CPA và conversion.",
        "columns": [
          "Nguồn",
          "Lead đủ chuẩn",
          "CPA",
          "Tỷ lệ chốt"
        ]
      }
    ]
  }
};
